
export default {
  name: 'AudioProductBanner',
  props: {
      region: {
          type: String,
          default: 'uk',
      },
  },
}
